import React from 'react';
import { Linkedin, NotebookPen } from 'lucide-react';

const CompanyProfile = () => {
    return (
        <section id="company" className="py-20 bg-white dark:bg-gray-800 transition-colors duration-300">
            <div className="container mx-auto px-4 md:px-6">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">Project NEXUS 運営会社概要</h2>
                </div>

                <div className="max-w-3xl mx-auto bg-gray-50 dark:bg-gray-700 rounded-xl overflow-hidden shadow-sm border border-gray-100 dark:border-gray-600">
                    <div className="divide-y divide-gray-200 dark:divide-gray-600">
                        <div className="flex flex-col md:flex-row p-6">
                            <div className="md:w-1/3 font-bold text-gray-900 dark:text-white mb-2 md:mb-0">運営会社名</div>
                            <div className="md:w-2/3 text-gray-600 dark:text-gray-300">
                                株式会社 eriver.jp<br />
                                <span className="text-sm text-gray-500 dark:text-gray-400">(エリバー ジェーピー)</span>
                            </div>
                        </div>
                        <div className="flex flex-col md:flex-row p-6">
                            <div className="md:w-1/3 font-bold text-gray-900 dark:text-white mb-2 md:mb-0">本店所在地</div>
                            <div className="md:w-2/3 text-gray-600 dark:text-gray-300">
                                東京都杉並区南荻窪
                            </div>
                        </div>
                        <div className="flex flex-col md:flex-row p-6">
                            <div className="md:w-1/3 font-bold text-gray-900 dark:text-white mb-2 md:mb-0">代表者</div>
                            <div className="md:w-2/3 text-gray-600 dark:text-gray-300">
                                Master of the GUILD / エンジニアリングマネージャー<br />
                                <div className="flex items-center gap-2 mt-1">
                                    <span>早川 武志 (Takeshi Hayakawa)</span>
                                    <a 
                                        href="https://www.linkedin.com/in/takeshi-hayakawa-04a10147" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="text-[#0a66c2] hover:opacity-80 transition-opacity"
                                        aria-label="LinkedIn Profile"
                                        title="LinkedIn Profile"
                                    >
                                        <Linkedin size={20} />
                                    </a>
                                    <a
                                        href="https://note.com/pjnexus"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-gray-700 dark:text-gray-300 hover:opacity-80 transition-opacity"
                                        aria-label="note記事"
                                        title="note記事"
                                    >
                                        <NotebookPen size={20} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompanyProfile;
